function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 216.37 289.57"
}, props), React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  strokeWidth: "4.5",
  d: "M214.12 181.39A105.94 105.94 0 0 1 2.28 184v-2.6a105.94 105.94 0 1 1 211.87 0z"
}), React.createElement("circle", {
  cx: "138.92",
  cy: "212.14",
  r: "35.63",
  strokeWidth: "4.5"
}), React.createElement("path", {
  strokeWidth: "4.5",
  d: "M174.28 207.65a35.65 35.65 0 0 1-70 3.8c-.63-2.67-.69-.94-.69-3.8m-87.52-76.42A30 30 0 1 1 2.25 184m189.21-67.18a20.91 20.91 0 1 1-29.19-26.54"
}), React.createElement("path", {
  strokeWidth: "4.5",
  d: "M2.25 176.51s7.54 10.37 28.75 4.88c20.33-5.28 17.1-34.16 17.1-34.16m103.39-35.67s19.95 22.57 38.71 2.77"
}), React.createElement("path", {
  strokeWidth: "5",
  d: "M108.62 91.17V4.78s16.31-7.31 26.8 4.22c11 12.07 35.47-4.43 35.47-4.43l.51 29s-16.77 16.17-41.77.81c0 0-11.25-5.78-20.36 2m-14.52 59.9c3 4 8.13 7.5 14 7.5s11-3.5 14-7.5"
}))));